import classes from "./VoiceOrderInstructions.module.css";

const VoiceOrderInstructions = () => {
  return (
    <div className={classes["voice-order-instructions"]}>
      <h2 className={classes["voice-order-instructions__header"]}>
        و إنت بتسجل طلبك الصوتي قولنا المعلومات دي:
      </h2>
      <ol className={classes["voice-order-instructions__list"]}>
        <li className={classes["voice-order-instructions__list-item"]}>
          إيه نوع قطع الغيار اللي انت محتاجها؟
        </li>
        <li className={classes["voice-order-instructions__list-item"]}>
          إيه ماركة السيارة ؟ (مثال : هيونداي، كيا)
        </li>
        <li className={classes["voice-order-instructions__list-item"]}>
          أوتوماتيك ولا مانيوال ؟ و كام CC ؟
        </li>
        <li className={classes["voice-order-instructions__list-item"]}>
          أي مواصفات خاصة ( خليجي, فئة )
        </li>
      </ol>
    </div>
  );
};

export default VoiceOrderInstructions;
